import store from "@/store";
import request from "@/utils/request";


export async function getNoticeList(params) {
    console.log("@@ get list : getNoticeList");
    let result = request.get("/api/customer/notice/",{params});
    return result;
}
export async function getNoticeItem(params) {
    console.log("@@ get list : getNoticeItem");
    let result = request.get("/api/customer/notice/detail/",{params});
    return result;
}

export async function setNoticeList(params) {
    console.log("@@ post save : setNoticeList");
    let result = request.post(`/api/customer/notice/save/`,params);
    return result;
}

export async function deleteNoticeList(params) {
    console.log("@@ delete : deleteNoticeList");
    let result = request.post(`/api/customer/notice/delete/`,params);
    return result;
}